// import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';

import { BaseTabsUpdateComponent, TabsContainerService, BaseDataService, UserService, ModalService, BaseUpdateComponent, QueryParameter, ModelDataService, DefgIniService, CompanyDataService, CompanyData, ConfirmationDialogButtons, ModelData, ModalSize, ErrorHandlerService, UserRightsService, TableContextMenuItem, NotificationService, LoaderService } from 'yt-ng-framework';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ViewChild } from '@angular/core';

import { EPrijemnica } from './eprijemnica';
import { EPrijemnicaView } from './eprijemnica-view';
import { EPrijemnicaService } from './eprijemnica-service';
import { EPrijemnicaUpdateComponent } from './eprijemnica-update.component';
import { HttpErrorResponse } from '@angular/common/http';
import { saveAs } from 'file-saver';

@Component({
  selector: "yt-eprijemnica-tab-update",
  templateUrl: "./eprijemnica-tab-update.component.html",
})
export class EPrijemnicaTabUpdateComponent
  extends BaseTabsUpdateComponent<EPrijemnica>
  implements OnInit {
  actionService: any;
  loadingSendEReceipt: boolean = false;
  loadingEUReceiptStatus: boolean = false;
  bojaStatusa = "transparent";
  formControlDataName: string;
  nazivStatusa: string;

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected tabsContainerService: TabsContainerService<EPrijemnica>,
    protected baseDataService: BaseDataService,
    protected userService: UserService,
    protected modalService: ModalService,
    protected modelDataService: ModelDataService,
    protected router: Router,
    protected defgIni: DefgIniService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService,
    protected companyDataService: CompanyDataService,
    protected errorService: ErrorHandlerService,
    protected userRightsService: UserRightsService,
    private eprijemnicaService: EPrijemnicaService,
    loaderService?: LoaderService,
    changeDetectorRef?: ChangeDetectorRef

  ) {
    super(activatedRoute, tabsContainerService, baseDataService, userService);
  }

  @ViewChild('baseUpdate', { static: true }) eprijBaseUpdate: EPrijemnicaUpdateComponent;
  ngOnInit() {
    super.ngOnInit();

    this.eprijemnicaService.baseUpdateComponent = this.eprijBaseUpdate;
    this.eprijemnicaService.baseTabUpdate = this;
    this.ContextMenuSettings();

    if (!this.baseUpdateComponent) return;

    if (!this.baseUpdateComponent.Item) {
      this.baseUpdateComponent.Item = new EPrijemnica();
      this.baseUpdateComponent.Item.ID = -1;
    }

    this.baseUpdateComponent.IDProcessed.subscribe((value) => {
          if (value && this.baseUpdateComponent.Item.ID > 0){
            this.bojaStatusa = this.baseUpdateComponent.Item.StatusColor;
            this.nazivStatusa = this.baseUpdateComponent.Item.StatusTooltip;
          }
          else
          {
            this.bojaStatusa = "transparent";
            this.nazivStatusa = "";
          } 
        });

    this.formControlDataName =
      this.modelData["MainList"]["FormControlDataName"];
    
    this.baseUpdateComponent.ItemSaved.subscribe((value) => {
      if (value && this.baseUpdateComponent.Item.ID <= 0)
        this.RefreshStatusReceipt(this.baseUpdateComponent.Item.ID);
    }); 

  }

SendEReceipt(item: EPrijemnica){
    if (!this.baseUpdateComponent.canDeactivate()) {
        this.modalService.ShowConfirmationDialog(
            "Obaveštenje",
            "Dokument nije sačuvan. Sačuvaj i pošalji?",
            "question",
            ConfirmationDialogButtons.ConfirmCancel
        ).result.then((result) => {
            if (result === ConfirmationDialogButtons.ConfirmCancel || result === true) {
                this.baseUpdateComponent.SaveItem();
                if (!(this.baseUpdateComponent.baseInlineContainer &&
                    this.baseUpdateComponent.baseInlineContainer.baseInlineUpdateComponent &&
                    this.baseUpdateComponent.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent &&
                    this.baseUpdateComponent.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent.canDeactivate())) {
                    this.baseUpdateComponent.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent.SaveItem();
                }
                item = this.baseUpdateComponent.Item;
                
                this.StartSendingProcess(item);
            }
        }).catch(() => {
            return;
        });
        return; 
    }

    this.StartSendingProcess(item);
  }

  private StartSendingProcess(item: EPrijemnica) {
      if (this.baseUpdateComponent.baseFormGroup.valid) {
        let _id: Number = item.ID;
          let _masterDokumID: Number = item.MasterDokumID;
          let _statusID = item.StatusID;
          let _today: Date = new Date();
          let _datum: Date = new Date(item.Datum["year"], item.Datum["month"] - 1, item.Datum["day"]);
  
          if (new Date(_datum.toLocaleDateString()) < new Date(_today.toLocaleDateString())) {
              this.translateService.get(["EPRIJEMNICA.DATE.DATECANNOTBEDIFFERENTFROMTODAYS"])
                  .subscribe(translate => {
                      this.toastrService.warning(translate["EPRIJEMNICA.DATE.DATECANNOTBEDIFFERENTFROMTODAYS"]);
                  });
              return false;
          }
          let salji = true;
          var parameters1 = [];
          var parameter = new QueryParameter();
          parameter.Name = 'statusID';
          parameter.Value = _statusID == null ||  _statusID == 0 ? -1 : _statusID;
          parameters1.push(parameter);
  
          this.baseDataService.Get('EPrijemnica', 'GetDocStatusName', parameters1, null).subscribe(data => {
            let salji = true;
  
            this.baseDataService.Get('EPrijemnica', 'GetDocStatusNaziv', parameters1, null).subscribe(dataNaziv => {
              if (data && data.toString().toLowerCase() != "unknown" && data.toString().toLowerCase() != "404" &&
                  ((data.toString().toLowerCase() == "sent" && this.modalService.ShowConfirmationDialog("Obaveštenje o statusu dokumenta", "Dokument je već poslat na portal.", 'warning', ConfirmationDialogButtons.Ok)) ||
                  (data.toString().toLowerCase() == "deliveryconfirmed" && this.modalService.ShowConfirmationDialog("Obaveštenje o statusu dokumenta", "Dokument je već isporučen.", 'warning', ConfirmationDialogButtons.Ok)) ||
                  confirm("Status računa je " + dataNaziv.toString() + " da li zaista želite da ga pošaljete na portal?") == false)) {
                  salji = false;
              }
  
              if (salji){
                let _modelData = this.modelDataService.GetModelDataByPath("send-eotpremnica");
                let idParameter = new QueryParameter("ePrijemnicaID", item.ID);
                let masterIdParameter = new QueryParameter("masterDokumID", _masterDokumID);
                let formControlDataNameParameter = new QueryParameter("formControlDataName", this.formControlDataName);

                if (_modelData) {
                  this.modalService.ShowModal(0, _modelData, null, true, [idParameter, masterIdParameter, formControlDataNameParameter]).result.then((item) => {
                    this.baseUpdateComponent.Item.OsvezivogStatusa = true;
                    this.RefreshStatusClick();
                    }, (reason) => {
                  });
                }
              }
            });
          });
          
      }
    }
  
    RefreshStatusReceipt(id: number) {
      if (id > 0) {
              this.loadingEUReceiptStatus = true;
              let idParameter = new QueryParameter("id", id);
              let vrsta = this.modelData["MainList"]["UserRightsModelName"];
              let vrstaParameter = new QueryParameter("vrsta", vrsta);            
              if (this.baseUpdateComponent.Item.OsvezivogStatusa) {            
                this.baseDataService
                  .Get("EPrijemnica", "OsveziStatus", [idParameter,vrstaParameter], EPrijemnicaView)
                  .subscribe((data: EPrijemnicaView[]) => {
                    if (data != null && data.length > 0)
                    {
                      this.bojaStatusa = data[0].StatusColor;
                      this.nazivStatusa = data[0].StatusTooltip;
                    } 
                    else 
                      {
                        this.bojaStatusa = "transparent";
                        this.nazivStatusa = "";
                      }

                    this.baseDataService.GetByID("EPrijemnica",id,EPrijemnica)
                    .subscribe((data: EPrijemnica) => {
                      if (data){
                        this.baseUpdateComponent.Item = data;
                        this.tabsContainerService.EmitItem(data);
                      }
                      this.baseUpdateComponent.ItemLoaded.emit(this.baseUpdateComponent.Item);
                    })

                  }
                  ,error => {
                    throw error;
                  }
                  );
              } else {
                this.baseDataService
                  .Get("EPrijemnica", "GetViewItemByID", [idParameter], EPrijemnicaView)
                  .subscribe((data:any) => {
                    if (data != null && data.StatusColor!=null)
                      {
                        this.bojaStatusa = data.StatusColor;
                        this.nazivStatusa = data.StatusTooltip;
                      } 
                    else 
                      {
                        this.bojaStatusa = "transparent";
                        this.nazivStatusa = "";
                      }
                  }
                  ,error => {
                    throw error;
                  }
                  );
                if (this.baseUpdateComponent.Item.ProvajderID)
  
                  this.translateService.get('EPRIJEMNICA.STATUS.NEMOZEDAOSVEZI')
                  .subscribe(translate => {
                    window.alert(translate);
                  })
              }
              this.loadingEUReceiptStatus = false;
        }
      }
    
  
  
    RefreshStatusClick() {
      this.RefreshStatusReceipt(this.baseUpdateComponent.Item.ID);
    }
    ContextMenuSettings() {
    if (this.defaultUpdateButtons) {
        this.defaultUpdateButtons.ButtonsConfig.ContextMenuButtonConfig.Visible = this.formControlDataName == "eprijemnice/izeprijemnica" ? true : false;
        this.defaultUpdateButtons.ButtonsConfig.SaveButtonConfig.Visible = false;
        this.defaultUpdateButtons.ButtonsConfig.ResetButtonConfig.Visible = false;
        
      if (!this.actionService) {
        this.actionService = this.eprijemnicaService;
      }
  
      if (!this.actionService.baseUpdateComponent) {
          this.actionService.baseUpdateComponent = this.baseUpdateComponent;
      }
      
        if (this.defaultUpdateButtons.ButtonsConfig.ContextMenuButtonConfig.Visible) {
          
            const originalToggleContextMenu = this.defaultUpdateButtons.ToggleContextMenu.bind(this.defaultUpdateButtons);

            this.defaultUpdateButtons.ToggleContextMenu = (event: MouseEvent) => {
              if (this.baseUpdateComponent.baseFormGroup.invalid) {
                this.baseUpdateComponent.SaveItem();
                return;
            }
                this.eprijemnicaService.checkUnsavedChanges(() => {
                    originalToggleContextMenu(event);  
                });
            };
        } else {
            this.defaultUpdateButtons.ToggleContextMenu = () => {};
        }

      
    }
  }
  PrihvatiPrijemnicu(id:number){
    this.eprijemnicaService.PrihvatiPrijemnicuService(id);
  }
  OdbijPrijemnicu(id:number){
    this.eprijemnicaService.OdbijPrijemnicuService(id);
  }

  PreuzmiPriloge():void {
    let _id = this.baseUpdateComponent.Item.EpID;
    let parameters = { epID: _id}; 
    this.baseDataService.GetFile("EPrijemnica","PreuzmiPriloge",parameters,false)
    .subscribe((response : any)=>{
      let filename = 'downloaded_file';
      const contentDisposition = response.headers.get('content-disposition');

      if (contentDisposition) {
        const match = /filename\*=UTF-8''([^;]+)|filename="?([^"]+)"?/i.exec(contentDisposition);
        const extractedName = match?.[1] || match?.[2];

        if (extractedName) {
          filename = decodeURIComponent(extractedName).split(";")[0];
        }
      }
      let blob = new Blob([response.body], { type: response.headers.get('content-type') });
      saveAs(blob, filename);
    },
     error =>{
    let _message;
    let translatedMessage: string = "";
    if (error instanceof HttpErrorResponse) {
      _message = this.errorService.getServerMessage(error);
      if (_message instanceof ArrayBuffer) {
        _message = String.fromCharCode.apply(null, new Uint8Array(_message));
        let message: string = _message;
        if (message.includes("EPRIJEMNICA")) {
          let messageArray: string[] = message.split(';');
          messageArray.forEach((element, index) => {
            messageArray[index] = "FW.ERRORS." + element;
          });
          this.translateService.get(messageArray)
            .subscribe(translate => {
              translatedMessage = Object.keys(translate).map(key => translate[key]).join('\r\n');
            });
        }
        else
          translatedMessage = message;
      }
      else {
        translatedMessage = this.errorService.getClientMessage(error);
      }
    }
    this.modalService.ShowConfirmationDialog("Problemi kod preuzimanja", translatedMessage, "warning", ConfirmationDialogButtons.Ok);

    })
  }

  PrintPDF(): void {
    let _id = this.baseUpdateComponent.Item.EpID;
    let parameters = { epID: _id}; 
    this.baseDataService.GetFile("EPrijemnica","PrintPdf",parameters)
    .subscribe((result : Blob)=>{
     const fileURL = URL.createObjectURL(result);
      const pdfWindow = window.open("", "_blank");

      if (pdfWindow) {
        pdfWindow.document.writeln(
          `<iframe width="100%" height="100%" src="${fileURL}" frameborder="0"></iframe>`
        );
      }
    
    },
     error =>{
    let _message;
    let translatedMessage: string = "";
    if (error instanceof HttpErrorResponse) {
      _message = this.errorService.getServerMessage(error);
      if (_message instanceof ArrayBuffer) {
        _message = String.fromCharCode.apply(null, new Uint8Array(_message));
        let message: string = _message;
        if (message.includes("EPRIJEMNICA")) {
          let messageArray: string[] = message.split(';');
          messageArray.forEach((element, index) => {
            messageArray[index] = "FW.ERRORS." + element;
          });
          this.translateService.get(messageArray)
            .subscribe(translate => {
              translatedMessage = Object.keys(translate).map(key => translate[key]).join('\r\n');
            });
        }
        else
          translatedMessage = message;
      }
      else {
        translatedMessage = this.errorService.getClientMessage(error);
      }
    }
    this.modalService.ShowConfirmationDialog("Problemi kod preuzimanja", translatedMessage, "warning", ConfirmationDialogButtons.Ok);

    })

    
  }

}